import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar, Footer } from "Components";

export const UserLayout = () => {
  return (
    <>
      <Navbar />
      <div className="outlet_footer flex_c">
        <Outlet />
        <Footer />
      </div>
    </>
  );
};
